import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 5l-10 14","key":"svg-0"}]]

const IconSlash = createReactComponent('outline', 'slash', 'Slash', __iconNode);

export default IconSlash;